import styled from '@emotion/styled'

import { spacing } from '../../theme'

type Spacing = keyof typeof spacing

type ArcadeCardProps = { padding?: Spacing }

export const ArcadeCard = styled.article<ArcadeCardProps>`
  padding: ${({ theme, padding }) => theme.spacing[padding ?? 'defaultContent']};
`

export const ArcadeBorderedCard = styled(ArcadeCard)`
  border-radius: ${({ theme }) => theme.border.radius.medium};
  border-width: ${({ theme }) => theme.border.width.small};
  border-style: solid;
  border-color: ${({ theme }) => theme.arcadeColors.semantic.borderDivider};
`
